"use client";

import JournalMasthead from "@/src/components/journal-site/_partials/header/journal-masthead";
import BreadCrumbs from "@/src/components/journal-site/_partials/header/breadcrumbs/breadcrumbs";
import { Box } from "@mui/material";

const JournalSiteHeader = ({
  journal,
  mainJournal,
  breadcrumbs,
}: {
  journal: any;
  mainJournal: any;
  breadcrumbs: any[];
}) => {
  if (journal.is_main_site) {
    return (
      <Box sx={{ width: "100%", position: "relative", overflow: "visible" }}>
        <BreadCrumbs breadcrumbs={breadcrumbs} journal={mainJournal} />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", position: "relative", overflow: "visible" }}>
      <JournalMasthead journal={journal} />
      <BreadCrumbs breadcrumbs={breadcrumbs} journal={mainJournal} />
    </Box>
  );
};

export default JournalSiteHeader;
